import { NgModule } from '@angular/core';
import { HideDropdownOnScrollDirective } from './hide-dropdown-on-scroll.directive'
import { HideMultiselectOnScrollDirective } from './hide-multiselect-on-scroll.directive';

@NgModule({
  declarations: [HideDropdownOnScrollDirective,
    HideMultiselectOnScrollDirective],
  exports: [HideDropdownOnScrollDirective,
    HideMultiselectOnScrollDirective]
})
export class HideDropdownOnScrollModule {}
